import React from "react";
import Layout from "../components/Layout";
import {GestionProtocolos } from "../components";
const AsignacionAgentes = () => {
  return (
    <>
      <Layout />
      <div>
        <GestionProtocolos />
      </div>
    </>
  );
};

export default AsignacionAgentes;
